import styled from "styled-components"

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 90vw;
  @media (min-width: 780px) {
    min-width: 450px;
  }
  @media (max-width: 425px) {
    background-color: white;
    position: fixed;
    top: 0;
    left: 0;
    min-width: 100vw;
    height: 100vh;
  }
  overflow: hidden;
`

export const Header = styled.div`
  margin: var(--size-4) var(--size-6) var(--size-2) var(--size-6);

  display: flex;
  justify-content: space-between;
  align-items: end;

  > :last-child {
    line-height: 28px;
    text-underline-offset: 3px;
    text-decoration: underline;

    cursor: pointer;
  }

  @media (max-width: 425px) {
    margin: var(--size-4) var(--size-2) var(--size-2) var(--size-2);
  }
`

export const Content = styled.div`
  position: relative;
  flex: 1;
  min-height: 70vh;
  margin-top: var(--size-6);
`
export const Divider = styled.div`
  height: 1px;
  width: 90%;
  margin: 0 auto;
  margin-top: -1px;
  background-color: var(--color-neutral-50);
`
export const BaseNotification = styled.div<{ viewed?: boolean }>`
  width: 100%;
  padding: var(--size-3) var(--size-6);

  ${(props) => !props.viewed && "background-color: var(--color-neutral-10);"}

  display: flex;

  > div:nth-child(2) {
    flex: 1;
    padding-left: var(--size-3);
    span {
      display: flex;
      align-items: end;

      &:nth-child(2) {
        margin: var(--size-1_5) 0;
      }
      &:nth-child(3) {
        margin-top: var(--size-3);
      }
      > p {
        margin-right: var(--size-1);
      }

      &:not(:first-child) {
        color: var(--color-neutral-200);
      }
    }
  }
  > div:last-child {
    align-self: center;
  }
`

export const EmptyList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  align-items: center;
  padding: var(--size-20) 0;

  > svg {
    fill: var(--color-neutral-75);
    margin-bottom: var(--size-6);
  }
  > span {
    font: var(--font-body);
  }
`
export const DropdownItem = styled.div`
  display: flex;

  align-items: center;
  padding: var(--size-0_5) var(--size-0_25);

  > svg {
    fill: var(--color-neutral-75);
    margin-right: var(--size-4);
  }
`
